module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n\n  input： "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input_value),
      expression: "input_value"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.input_value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.input_value = $event.target.value
      }
    }
  }), _vm._v(",\n  输入的值：" + _vm._s(_vm.input_value) + "\n  "), _c('hr'), _vm._v("\n  text area： "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.textarea_value),
      expression: "textarea_value"
    }],
    domProps: {
      "value": (_vm.textarea_value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.textarea_value = $event.target.value
      }
    }
  }), _vm._v(",\n  输入的值：" + _vm._s(_vm.textarea_value) + "\n  "), _c('hr'), _vm._v("\n  radio:\n  "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.radio_value),
      expression: "radio_value"
    }],
    attrs: {
      "type": "radio",
      "value": "A"
    },
    domProps: {
      "checked": _vm._q(_vm.radio_value, "A")
    },
    on: {
      "__c": function($event) {
        _vm.radio_value = "A"
      }
    }
  }), _vm._v(" A,\n  "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.radio_value),
      expression: "radio_value"
    }],
    attrs: {
      "type": "radio",
      "value": "B"
    },
    domProps: {
      "checked": _vm._q(_vm.radio_value, "B")
    },
    on: {
      "__c": function($event) {
        _vm.radio_value = "B"
      }
    }
  }), _vm._v(" B,\n  "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.radio_value),
      expression: "radio_value"
    }],
    attrs: {
      "type": "radio",
      "value": "C"
    },
    domProps: {
      "checked": _vm._q(_vm.radio_value, "C")
    },
    on: {
      "__c": function($event) {
        _vm.radio_value = "C"
      }
    }
  }), _vm._v(" C,\n  输入的值：\n  " + _vm._s(_vm.radio_value) + "\n  "), _c('hr'), _vm._v("\n  checkbox:\n  "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkbox_value),
      expression: "checkbox_value"
    }],
    attrs: {
      "type": "checkbox",
      "true-value": true,
      "false-value": false
    },
    domProps: {
      "checked": Array.isArray(_vm.checkbox_value) ? _vm._i(_vm.checkbox_value, null) > -1 : (_vm.checkbox_value)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.checkbox_value,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.checkbox_value = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.checkbox_value = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkbox_value = $$c
        }
      }
    }
  }), _vm._v(" ,\n  输入的值：\n  " + _vm._s(_vm.checkbox_value) + "\n  "), _c('hr'), _vm._v("\n  select:\n  "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.select_value),
      expression: "select_value"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.select_value = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.options), function(e) {
    return _c('option', {
      domProps: {
        "value": e.value
      }
    }, [_vm._v("\n      " + _vm._s(e.text) + "\n    ")])
  })), _vm._v("\n  输入的值：" + _vm._s(_vm.select_value) + "\n\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2dd56b87"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FormInput.vue
// module id = 63
// module chunks = 0